import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../../config';
import apiService from '../../../utlis/apiService';
import { ArrowBackIos as BackButton } from '@mui/icons-material';
import {
  TextField,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup
} from '@mui/material';
import { disabledNameforRoles } from '../../../utlis/commonFunction';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreateUserForm = () => {
  let query = useQuery();
  let id = query.get('id');
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState({
    "Approval Management": [
      "readApproval",
      "approveApproval",
      "rejectApproval",
    ],
    "Registration Management": [
      "readRegistration",
      "operationsApproveRegistration",
      "accountsApproveRegistration",
      "editRegistration",
      "rejectRegistration",
      "resendRegistration",
    ],
    "Referrer Management": [
      "readReferrer",
      "markReferrerAsPaid",
    ],
    "Faculty Management": [
      "createFaculty",
      "readFaculty",
      "updateFaculty",
      "deleteFaculty"
    ],
    "Student Management":[
      "createStudent",
      "readStudent",
      "updateStudent",
      "deleteStudent",
      "manageOperations",
      "manageAccounts",
      "readStudentOTP",
    ],
    "Mentor Management":[
      "createMentor",
      "readMentor",
      "updateMentor",
      "deleteMentor"
    ],
    "Coordinator Management":[
      "createCoordinator",
      "readCoordinator",
      "updateCoordinator",
      "deleteCoordinator"
    ],
    "Branch Management":[
      "createBranch",
      "readBranch",
      "updateBranch",
      "deleteBranch"
    ],
    "Classroom Management":[
      "createClassroom",
      "readClassroom",
      "updateClassroom",
      "deleteClassroom"
    ],
    "Batch Management":[
      "createBatch",
      "readBatch",
      "updateBatch",
      "deleteBatch",
      "readExamMark",
      "enterExamMark",
      "deleteExamFromBatch",
      "updateNameTail",
    ],
    "Draft Batch Management":[
      "createDraftBatch",
      "readDraftBatch",
      "updateDraftBatch",
      "deleteDraftBatch",
      "updateDraftNameTail",
    ],
    "Academic Holiday":[
      "createAcademicHoliday",
      "readAcademicHoliday",
      "updateAcademicHoliday",
      "deleteAcademicHoliday",
    ],
    "Emi Scheme":[
      'createEmiScheme',
      'readEmiScheme',
      'updateEmiScheme',
      'deleteEmiScheme',
    ],
    "Status Type":[
      'createStatusType',
      'readStatusType',
      'updateStatusType',
      'deleteStatusType',
    ],
    "Student Tickets":[
      'createStudentTickets',
      'readStudentTicketActivity',
      'readStudentTickets',
      'forwardStudentTickets',
      'closeStudentTickets',
      'approveStudentTickets',
      'readAllStudentTickets',
    ],
    "Subject Management":[
      "createSubject",
      "readSubject",
      "updateSubject",
      "deleteSubject"
    ],
    "Course Management":[
      "createCourse",
      "readCourse",
      "updateCourse",
      "deleteCourse"
    ],
    "Topic Management":[
      "createTopic",
      "readTopic",
      "updateTopic",
      "deleteTopic"
    ],
    "Category Management":[
      "createCategory",
      "readCategory",
      "updateCategory",
      "deleteCategoryl"
    ],
    "Schedule Management":[
      "createSchedule",
      "readSchedule",
      "updateSchedule",
      "deleteSchedule",
      "updateDate",
      "updateAttendance"
    ],
    "Exam Management":[
      "createExam",
      "readExam",
      "updateExam",
      "deleteExam"
    ],
    "Recordings Management":[
      "readApplication",
      'createApplication',
      'editApplication',
      'sendApplicationLink',
      "readAdmission",
      "changeAdmissionStatusToAccessGranted",
      "changeAdmissionStatusToDisabled",
      'exportRecordingsAdmission',
    ],
    "Role Management":[
      "createRole",
      "readRole",
      "updateRole",
      "deleteRole"
    ],
    "User Management":[
      "createUser",
      "readUser",
      "updateUser",
      "deleteUser"
    ],
    "Schedule Report":[
      "readScheduleReport",
    ],
    "Fee Receivable Report":[
      "readFeeReceivableReport",
      "exportFeeReceivableReport",
    ],
    "Fee Received Report":[
      "readFeeReceivedReport",
      "exportFeeReceivedReport",
    ],
    "Admission Report":[
      "readAdmissionReport",
      "readCourseFee",
      "readAdditionalFee",
      "readAdmissionFee",
      "readFeeCollected",
      "readDueNotCollected",
      "readOutstanding",
      "readDiscount",
      "readRefund",
      "readUnallocatedFee",
      "exportAdmissionReport",
      'readSalesAgentReport',
    ],
    "Students Report":[
      "readStudentsReport",
      "exportStudentsReport",
    ],
    "Batch Report":[
      "readBatchReport",
    ],
    "Academics Report":[
      "readAcademicsReport",
    ],
    "Attendance Report":[
      "readAttendanceReport",
    ],
    "Transfer Report":[
      "readTransferReport",
    ],
    "Activity Logs":[
      "readActivityLogs",
      "readStudentActivityLogs",
      "readBatchActivityLogs",
    ],
    "Settings":[
      "updateSettings",
    ],
    
  });

  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const [formData, setFormData] = useState({
    name: '',
  });


  useEffect(() => {
    const fetchRoleData = async () => {
      try {
        if (id) {
          const response = await apiService.get('/admin/getRole', {
            params: {
              id: id,
            },
          });
          console.log(response.data);
          const { name, permissions } = response.data;
          setFormData({ name });
          setSelectedPermissions(permissions);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchRoleData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePermissionChange = (permission) => {
    if (selectedPermissions.includes(permission)) {
      setSelectedPermissions(selectedPermissions.filter(p => p !== permission));
    } else {
      setSelectedPermissions([...selectedPermissions, permission]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const apiUrl = id
        ? `${config.apiUrl}/admin/updateRole?id=${id}`
        : `${config.apiUrl}/admin/createRole`;
      try {
        const response = await apiService.post(apiUrl, {
          name: formData.name,
          permissions: selectedPermissions,
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        navigate(-1);
        console.log(JSON.stringify(response.data));
      } catch (error) {
        alert(error?.response?.data?.error);
        console.error(error);
      }
    }
  };

  const validateForm = () => {
    // Implement validation logic here
    return true;
  };

  const disabledNames = disabledNameforRoles();

  return (
    <div>
      <h1 style={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
        <BackButton />
        {`Roles`}
      </h1>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" gutterBottom>
          {id ? 'Edit' : 'Create'} Role
        </Typography>

        <TextField
          label="Role Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          margin="normal"
          size="small"
          disabled={disabledNames.includes(formData.name)}
        />

        <Typography variant="h5" gutterBottom sx={{ marginTop: 4 }}>
          Permissions:
        </Typography>

        {Object.entries(permissions).map(([module, modulePermissions]) => (
          <div key={module} style={{ marginBottom: '20px' }}>
            <Typography variant="h6" gutterBottom style={{ marginBottom: '10px' }}>
              {module}
            </Typography>
            <FormGroup>
              {modulePermissions.map((permission) => (
                <FormControlLabel
                  key={permission}
                  control={
                    <Checkbox
                      checked={selectedPermissions.includes(permission)}
                      onChange={() => handlePermissionChange(permission)}
                      name={permission}
                    />
                  }
                  label={permission}
                  style={{ marginLeft: '10px' }}
                />
              ))}
            </FormGroup>
          </div>
        ))}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ marginTop: '20px' }}
        >
          {id ? 'Update Role' : 'Create Role'}
        </Button>
      </form>
    </div>
  );
};

export default CreateUserForm;
